export const url = 'https://sycris.up.railway.app';
// export const url = 'http://localhost:3100';